import * as Roles from '@/store/roles';

export const personActionsPermissions = {
  addPerson: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  addSyncedPerson: [Roles.Any],
  deletePerson: [Roles.Admin, Roles.ProjectLeader],
  fetchPersons: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  getPersonFiles: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  markMessagesRead: [Roles.Any],
  preparePersonEntity: [Roles.Any],
  syncPersonFiles: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  savePersonFile: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  savePerson: [Roles.Admin, Roles.ProjectLeader, Roles.SiteManager, Roles.SiteAssistant],
  savePersonProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  setPersonProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  syncPersonProperties: [Roles.Any],
  updateLoginTime: [Roles.Any],
  updateStatePersons: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/person/personActionsPermissions.js